const toastErrors = (e: any) => {
	const app = useNuxtApp()

	const error = (text: string) => {
		if (!process.server) {
			app.$toast.error({ message: text })
		}
	}
	if (!e.response) {
		if (!e.message || e.message === "") error(app.$i18n.t("something_went_wrong") as string)
		else error(e.message)
	} else if (!e.response._data || !e.response._data.errors || e.response._data.errors.length === 0) {
		if (!e.response.statusText || e.response.statusText === "") error(app.$i18n.t("something_went_wrong"))
		else if (e.response.status === 403) {
			error(app.$i18n.t("something_went_wrong"))
		} else error(e.response.statusText)
	} else {
		const message = String(
			Object.values(e.response._data.errors)
				.map((i: any) => Object.values(i))
				.flat()[0] || ""
		)
		if (message) error(message)
	}
}

export default toastErrors
